import { useSyncExternalStore } from "react";

const subscribe = () => () => {};
const inBrowser = () => true;
const inDocument = () => false;

// Browser-only decoration starts after React has attached to the built page.
export default function useHydrated() {
  return useSyncExternalStore(subscribe, inBrowser, inDocument);
}
